<div #switchPortalReactWrapperComponent></div>